import Vue from 'vue'
import store from '../../store'
import firebase from 'firebase/app'

export default {
  namespaced: true,
  state () {
    return {
      groups: [],
      reference: null
    }
  },
  getters: {
    groups (state) {
      return state.groups
    },
    reference (state) {
      return state.reference
    }
  },
  mutations: {
    init (state) {
      state.groups = []
    },
    add (state, payload) {
      state.groups.push(payload)
    },
    update (state, payload) {
      const index = state.groups.findIndex(group => group.key === payload.key)
      if (index !== -1) {
        Vue.set(state.groups, index, payload)
      }
    },
    remove (state, payload) {
      const index = state.groups.findIndex(group => group.key === payload.key)
      if (index !== -1) {
        state.groups.splice(index, 1)
      }
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({ commit }) {
      commit('init')
    },
    subscribe ({ commit }) {
      return new Promise((resolve, reject) => {
        var user = this.getters['authUser/user']
        const db = firebase.firestore()
        const settings = { timestampsInSnapshots: true }
        db.settings(settings)
        var keys = Object.keys(user.services)
        var tempKeys = []
        var count = 0
        for (var i in keys) {
          if (user.services[keys[i]]) {
            tempKeys.push(keys[i])
            count += 1
          }
        }
        var dbRef = db.collection('groups')
        if (user.role === 'admin' || count > 1) {
          var reference = dbRef.where('enable', '==', true).onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              const payload = {
                key: change.doc.id,
                owner: change.doc.data().owner,
                services: change.doc.data().services,
                users: change.doc.data().users,
                name: change.doc.data().name,
                subTitle: change.doc.data().subTitle,
                icon: change.doc.data().icon,
                routine: change.doc.data().routine,
                chats_ref: change.doc.data().chats_ref,
                enable: change.doc.data().enable,
                createdAt: change.doc.data().createdAt,
                updatedAt: change.doc.data().updatedAt
              }
              var check = false
              for (var k in user.services) {
                if (user.services[k] && payload.services[k]) {
                  check = true
                }
              }
              if (change.type === 'added' && (user.role === 'admin' || check)) {
                commit('add', JSON.parse(JSON.stringify(payload)))
              } else if (change.type === 'modified') {
                commit('update', JSON.parse(JSON.stringify(payload)))
              } else if (change.type === 'removed') {
                commit('remove', JSON.parse(JSON.stringify(payload)))
              }
            })
            resolve()
          })
        } else if (tempKeys.length === 1) {
          reference = dbRef.where('services.' + tempKeys[0], '==', true).where('enable', '==', true).onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              const payload = {
                key: change.doc.id,
                owner: change.doc.data().owner,
                services: change.doc.data().services,
                users: change.doc.data().users,
                name: change.doc.data().name,
                subTitle: change.doc.data().subTitle,
                icon: change.doc.data().icon,
                routine: change.doc.data().routine,
                chats_ref: change.doc.data().chats_ref,
                enable: change.doc.data().enable,
                createdAt: change.doc.data().createdAt,
                updatedAt: change.doc.data().updatedAt
              }
              if (change.type === 'added') {
                commit('add', JSON.parse(JSON.stringify(payload)))
              } else if (change.type === 'modified') {
                commit('update', JSON.parse(JSON.stringify(payload)))
              } else if (change.type === 'removed') {
                commit('remove', JSON.parse(JSON.stringify(payload)))
              }
            })
            resolve()
          })
        } else {
          resolve()
        }
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      var reference = store.getters['group/reference']
      return new Promise((resolve, reject) => {
        if (reference) {
          reference()
          commit('reference', null)
          commit('init')
          resolve()
        } else {
          resolve()
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Group.js